import React from 'react';
import PropTypes from 'prop-types';
import styles from './andOn.css';
import { Row, Container } from "react-bootstrap";
import StampingAndOnBlock from "./andOnBlock.js";

const StampingAndOn = () => (
  <div className={styles.andOn} data-testid="andOn">
    <Container fluid>
      <Row>
        <StampingAndOnBlock
          machineName = {"Fanuk 1"}
          partName = {"Part 1"}
          userName = {"User 1"}
          downTime = {"11"}
          rQty = {"10"}
          oee = {"89"}
          oilTemp = {"34"}
          metalTemp = {"78"}
          dieTemp = {"67"}
        />
        <StampingAndOnBlock
          machineName = {"Fanuk 2"}
          partName = {"Part 2"}
          userName = {"User 2"}
          downTime = {"12"}
          rQty = {"11"}
          oee = {"88"}
          oilTemp = {"41"}
          metalTemp = {"66"}
          dieTemp = {"57"}
        />
      </Row>
    </Container>
  </div>
);

StampingAndOn.propTypes = {};

StampingAndOn.defaultProps = {};

export default StampingAndOn;
